export enum HttpHeader {
  AUTHORIZATION = 'Authorization',
}
